/**
 * @Author: WangZhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 15:10:43
 * @FilePath: /m-anquan-baidu-com/src/containers/product/vdc.js
 * @Description: 墨源文件威胁感知系统
 */
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {SearchBar, ImagePicker} from 'antd-mobile';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import {fetchUrlUpload} from '../../actions/fileCheckAction';

class Vdc extends PureComponent {
    static propTypes = {
        fetchUrlUpload: PropTypes.func,
        bannerInfo: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            vdcType: 'search',
            vdcValue: '',
            srcollTop: 0,
            fileHint: '请上传要检测的文件，文件大小不超过15M',
            fileWaring: false,
            vdcPage: false,
            vdcText: '请输入待检测文件对应的md5',
            vdcInputHint: '',
            upIng: false
        };
    }

    componentDidMount() {
    }

    clear = () => {
        this.setState({
            value: '',
            vdcPage: false
        });
        window.scrollTo(0, this.state.srcollTop);
    };

    onChange = vdcValue => {
        this.setState({vdcValue});
    };

    onSubmit = value => {
        if (!value) {
            return;
        }
        let vdcType = this.state.vdcType;
        let json = {};

        if (vdcType === 'search') {
            json = {
                resource: value
            };
        } else {
            json = {
                url: value
            };
        }

        this.props.fetchUrlUpload(json, vdcType === 'search' ? 'report' : 'urlUpload').then(data => {
            let obj = data.data;
            if (obj.status === 0) {
                if (obj.data.is_auth === 'bot') {
                    this.setState({
                        vdcPage: false,
                        vdcInputHint: '检测结果异常，请重新检测。'
                    });
                    return;
                }
                if (vdcType === 'search') {
                    location.href = `/m/fileCheck/report/${value}`;
                } else {
                    location.href = `/m/fileCheck/task/${obj.data.task_id}`;
                }
            } else {
                this.setState({
                    vdcPage: false,
                    vdcInputHint: obj.description
                });
            }
        });
    };

    onUpImgChange = files => {
        if (files[0].file.size > 1048576 * 15) {
            this.setState({
                fileWaring: true,
                fileHint: '文件超出大小限制'
            });
            return;
        }
        this.setState({
            upIng: true
        });
        let json = {
            files: files[0].file
        };

        this.props.fetchUrlUpload(json, 'fileUpload').then(data => {
            let obj = data.data;
            if (obj.status === 0) {
                if (obj.data.is_auth === 'bot') {
                    this.setState({
                        upIng: false,
                        fileWaring: true,
                        fileHint: '检测结果异常，请重新检测。'
                    });
                    return;
                }
                this.setState({
                    upIng: false,
                    fileWaring: false,
                    fileHint: '请上传要检测的文件，文件大小不超过15M'
                });
                location.href = `/m/fileCheck/task/${obj.data.task_id}`;
            } else {
                this.setState({
                    upIng: false,
                    fileWaring: true,
                    fileHint: obj.description
                });
            }
        });

    };

    render() {
        let bannerInfo = this.props.bannerInfo;
        let {vdcType, vdcText, upIng, vdcValue, vdcPage, fileHint, fileWaring, vdcInputHint} = this.state;

        let proinfoBox = [
            {
                title: '精准检测',
                'mobile_pic': require('../../asset/image/product/icon_jingzhunjiance.svg'),
                content: '通过多家评测机构认证，独有的深度学习分析引擎，准确识别出多种平台下不同文件格式可能存在的安全风险'
            },
            {
                title: '高吞吐性',
                'mobile_pic': require('../../asset/image/product/icon_gaotuntu.svg'),
                content: '支持每秒数万级并发查询，每日千万级新文件分析检测能力'
            },
            {
                title: '快速接入',
                'mobile_pic': require('../../asset/image/product/icon_kuaisujieru.svg'),
                content: '接口简单易用，不需要太多开发工作即可快速上线使用'
            },
            {
                title: '隐私保护',
                'mobile_pic': require('../../asset/image/product/icon_yinsibaohu.svg'),
                content: '依托百度多年积累的文件知识库，仅需文件特征即可获得文件鉴定结果'
            }
        ];

        let profunBox = [
            {
                title: '文件哈希检查',
                content: '可以根据文件内容的hash值，查询文件的威胁的详细信息。'
            },
            {
                title: '文件内容检查',
                content: '可以上传文件，通过文件内容进行异步的文件结果扫描，获取文件扫描结果。'
            },
            {
                title: '文件URL检查',
                content: '可以提供仅提供文件下载路径，后台下载后对文件内容进行检查识别。'
            },
            {
                title: '威胁详情查询',
                content: '可以通过文件的部分信息，进行检索存在威胁的文件信息详情。'
            },
            {
                title: '威胁文件下载',
                content: '可以通过文件的哈希值，获取到存在危险的文件内容，需要进行相关保密合约的签署。'
            }
        ];
        return (
            <div className={'product dc'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    依托百度安全多年积累的数亿级文件黑名单和智能文件安全分析引擎，
                    帮助用户在涉及文件相关的场景中对风险文件进行快速准确的甄别，
                    降低恶意代码攻击带来的风险，提升用户安全体验。
                </div>

                <div className={'product-vdc'}>
                    <div className={'product-mod'}>
                        <ProductTitle title={'文件安全检测'}/>
                    </div>

                    <div className={'product-mod'}>
                        <div className={'vdc-mod'}>
                            <div className={'vdc-tab'}>
                                <div
                                    className={vdcType === 'search' ? 'vdc-search on' : 'vdc-search'}
                                    onClick={() => {
                                        this.setState({
                                            vdcValue: '',
                                            vdcType: 'search',
                                            vdcInputHint: '',
                                            vdcText: '请输入待检测文件对应的md5'
                                        });
                                    }}
                                >
                                    <i/>搜索
                                </div>
                                <div
                                    className={vdcType === 'url' ? 'vdc-url on' : 'vdc-url'}
                                    onClick={() => {
                                        this.setState({
                                            vdcValue: '',
                                            vdcType: 'url',
                                            vdcInputHint: '',
                                            vdcText: '请输入待检测文件对应的url'
                                        });
                                    }}
                                >
                                    <i/>URL
                                </div>
                                <div
                                    className={vdcType === 'file' ? 'vdc-file on' : 'vdc-file'}
                                    onClick={() => {
                                        this.setState({
                                            vdcType: 'file',
                                            vdcInputHint: ''
                                        });
                                    }}
                                >
                                    <i/>文件检测
                                </div>
                            </div>
                            {
                                vdcType === 'file'
                                    ? <div className={'file-mod'}>
                                        <div className={'file-btn-box pr'}>
                                            {
                                                !upIng
                                                    ? <div className={'m-btn'}>上传文件</div>
                                                    : <div className={'m-btn file-btn'}>文件上传中</div>
                                            }
                                            {
                                                !upIng
                                                    ? <ImagePicker
                                                        accept={'*/*'}
                                                        multiple={false}
                                                        capture={true}
                                                        onChange={this.onUpImgChange}
                                                        selectable={true}
                                                    />
                                                    : null
                                            }
                                        </div>
                                        <div className={fileWaring ? 'file-hint on' : 'file-hint'}>
                                            {fileHint}
                                        </div>
                                    </div>
                                    : <div>
                                        <div
                                            className={'vdc-input'}
                                            onClick={() => {
                                                this.setState({
                                                    vdcPage: true,
                                                    srcollTop: document.documentElement.scrollTop
                                                    || document.body.scrollTop
                                                }, () => {
                                                    window.scrollTo(0, 0);
                                                    this.manualFocusInst.focus();
                                                });
                                            }}
                                        >
                                            {vdcText}
                                        </div>
                                        {
                                            vdcInputHint
                                                ? <div className={'vdc-input-hint'}>
                                                    {vdcInputHint}
                                                </div>
                                                : null
                                        }

                                    </div>
                            }

                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'产品特色'}/>
                </div>

                <div className={'product-mod'}>
                    {
                        proinfoBox.map((item, index) => {
                            return <div key={index} className={'proinfo-box mui-flex'}>
                                <div className={'proinfo-box-icon'}>
                                    <img
                                        src={item.mobile_pic}
                                        width={'100%'}
                                        alt={item.title}
                                    />
                                </div>
                                <div className={'cell'}>
                                    <div className={'proinfo-box-title'}>{item.title}</div>
                                    <div className={'proinfo-box-des'}>
                                        {item.content}
                                    </div>
                                </div>
                            </div>;
                        })
                    }
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'产品功能'}/>
                </div>


                <div className={'product-mod'}>
                    {
                        profunBox.map((item, index) => {
                            return <div className={'profun-box mui-flex'} key={index}>
                                <div className={'profun-box-icon'}>
                                    <div className={'star'}>
                                    </div>
                                </div>
                                <div className={'cell'}>
                                    <div className={'profun-box-title'}>{item.title}</div>
                                    <div
                                        className={'profun-box-des'}
                                        dangerouslySetInnerHTML={{__html: item.content}}>
                                    </div>
                                </div>
                            </div>;
                        })
                    }
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'合作伙伴'}/>
                </div>
                <div className={'product-mod'}>
                    <img
                        src={require('../../asset/image/product/hezuohuoban.png')}
                        alt="合作伙伴"
                        style={{width: '100%'}}
                    />
                </div>
                {
                    vdcPage
                        ? <div className={'vdc-input-page'}>
                            <SearchBar
                                value={vdcValue ? vdcValue : ''}
                                placeholder={vdcText}
                                onSubmit={this.onSubmit}
                                onClear={() => {
                                    this.setState({
                                        value: ''
                                    });
                                }}
                                onFocus={() => {
                                    if (this.state.showHistory) {
                                        return;
                                    }
                                    this.setState({
                                        showHistory: true
                                    });
                                }}
                                ref={ref => this.manualFocusInst = ref}
                                onCancel={this.clear}
                                showCancelButton
                                onChange={this.onChange}
                            />
                        </div>
                        : null
                }
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchUrlUpload: (obj, type) => fetchUrlUpload(dispatch, obj, type)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Vdc);



// WEBPACK FOOTER //
// ./src/containers/product/vdc.js